import type { TypeFormFieldElement } from '../../../types/form';

// ----------------------------------------------------------------------------

function clearForm(form: HTMLFormElement): void {
    const elements = Array.from(form.elements) as TypeFormFieldElement[];

    for (const element of elements) {
        if (element instanceof HTMLInputElement) {
            if (element.type === 'checkbox' || element.type === 'radio') {
                element.checked = false;
                continue;
            }

            if (element.type === 'button' || element.type === 'submit' || element.type === 'reset') {
                continue;
            }

            element.value = '';
        }
        //
        else if (element instanceof HTMLSelectElement) {
            element.value = '';
        }
        //
        else if (element instanceof HTMLTextAreaElement) {
            element.value = '';
        }
    }
}

// ----------------------------------------------------------------------------

export default clearForm;
